import { LSimpleText } from '../../components/styled/Text.style'

const getPhoneNumberCmp = (phoneNumber: string) => <a
    href={`tel:${phoneNumber}`}
    style={{
        color: "#3C7B35",
        textDecoration: "none",
        cursor: "pointer"
    }}
>
    {phoneNumber}
</a>

export const LinearHelpRequestText = () => {
    return (
        <LSimpleText>Chiamaci al numero {getPhoneNumberCmp("+39 0517193456")} dal lunedì al venerdì, dalle 8:30 alle 20:00 e il sabato dalle 8:30 alle 14:00</LSimpleText>
    )
}


export const LinearErrorFileText = () => {
    return (
        <LSimpleText>Non puoi caricare un file più grande di 20MB.</LSimpleText>
    )
}


export const LinearNecessityInfoText = () => {
    return (
        <LSimpleText style={{ textAlign: "center" }}>In caso di necessità chiamaci al numero {getPhoneNumberCmp("+39 0517193456")}, dal lunedì al venerdì, dalle 8:30 alle 20:00 e il sabato dalle 8:30 alle 14:00, indicando il riferimento della pratica sopra riportato.<br /><br />A presto,<br /><i>Linear</i></LSimpleText>
    )
}
